import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const MarkerDiv = styled.div.withConfig({
  displayName: "InfiniteScrollMarker__MarkerDiv"
})(["height:1px;"]);
function useOnIntersectEntry(element, callback, rootRef, rootMargin) {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] !== callback || $[1] !== element || $[2] !== rootMargin || $[3] !== rootRef) {
    t0 = () => {
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          callback();
        }
      }, {
        root: rootRef.current,
        rootMargin
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    t1 = [element, callback, rootRef, rootMargin];
    $[0] = callback;
    $[1] = element;
    $[2] = rootMargin;
    $[3] = rootRef;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}
const InfiniteScrollMarker = t0 => {
  const $ = _c(1);
  const {
    handleIntersectionChange,
    rootMargin,
    scrollContainerRef
  } = t0;
  const [markerElementRef, setMarkerElementRef] = useState(null);
  useOnIntersectEntry(markerElementRef, handleIntersectionChange, scrollContainerRef, rootMargin);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(MarkerDiv, {
      ref: setMarkerElementRef,
      "data-test-id": "infinite-scroll-marker"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};
export default InfiniteScrollMarker;